module.exports = __webpack_public_path__ + "share_btn.10871e80.png";